import {formatNumber, NumberType} from '@/components/charts/numbers';
import {Chart, ScatterDataPoint, TimeUnit} from 'chart.js';
import 'chartjs-adapter-moment';

export default class LineChart {
    private chart: Chart;

    public constructor(
        element: HTMLCanvasElement,
        axisYTitle: string,
        dataSets: ChartDataSet[],
        period: TimeUnit,
        numberType: NumberType,
        language: string,
        currency: string,
        legend: boolean,
    ) {
        this.chart = new Chart(
            element,
            {
                type: 'line',
                data: {
                    datasets: dataSets,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: period,
                                displayFormats: {
                                    month: 'MM/YY',
                                },
                            },
                            title: {
                                font: {
                                    weight: 'bold',
                                },
                            },
                            ticks: {
                                maxTicksLimit: 30,
                            },
                        },
                        y: {
                            type: 'linear',
                            title: {
                                text: axisYTitle,
                                font: {
                                    weight: 'bold',
                                },
                                display: true,
                            },
                            ticks: {
                                callback: numberValue => formatNumber(
                                    typeof numberValue === 'string'
                                        ? parseInt(numberValue, 1)
                                        : numberValue,
                                    numberType,
                                    language,
                                    currency,
                                ),
                            },
                            beginAtZero: true,
                        },
                    },
                    plugins: {
                        legend: {
                            display: legend,
                            position: 'bottom',
                            labels: {
                                usePointStyle: true,
                            },
                        },
                        tooltip: {
                            mode: 'index',
                            intersect: false,
                            position: 'nearest',
                            bodySpacing: 5,
                            enabled: true,
                            callbacks: {
                                title: () => '',
                                label(item: any) {
                                    return item.dataset.label + ': '
                                        + formatNumber(item.raw[1], numberType, language, currency);
                                },
                            },
                        },
                    },
                    interaction: {
                        mode: 'index',
                        intersect: false,
                    },
                    hover: {
                        mode: 'nearest',
                        intersect: true,
                    },
                },
            },
        );
    }
}

export interface ChartDataSet {
    label: string;
    backgroundColor: string;
    borderColor: string;
    color: string;
    data: ScatterDataPoint[];
    lineTension: number;
}
